export default "__VITE_ASSET__CPtqshuD__"